import type { ReactNode } from 'react';
import { Card, Heading } from '@openroad/ui';

/**
 * The chrome the four prose pages in the footer share.
 *
 * They are the same shape — a title, a standfirst, and sections of text — so
 * they are one component with four sets of words rather than four screens that
 * drift apart the first time a heading size changes.
 */
export function InfoPage({
  title,
  standfirst,
  children,
}: {
  title: string;
  standfirst: string;
  children: ReactNode;
}) {
  return (
    <main className="mx-auto max-w-[720px] px-6 pt-12 pb-16">
      <Heading level="page" as="h1" className="mb-2">
        {title}
      </Heading>
      <p className="m-0 mb-8 text-body-lg leading-relaxed text-muted">{standfirst}</p>
      <div className="flex flex-col gap-5">{children}</div>
    </main>
  );
}

/** One section of an info page: a heading and its prose. */
export function InfoSection({ heading, children }: { heading: string; children: ReactNode }) {
  return (
    <Card radius="panel" className="p-6">
      <Heading level="card" as="h2" className="mb-2.5">
        {heading}
      </Heading>
      <div className="flex flex-col gap-3 text-base leading-relaxed text-ink-2">{children}</div>
    </Card>
  );
}
